import { useState } from "react";
import { Icon } from "./Icons";

export default function Login({ onLogin, error }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setLoading(true);
    try {
      await onLogin(password);
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="loginPage">
      <form className="loginCard" onSubmit={submit}>
        <span className="brandMark loginMark"><Icon name="mail" size={30} /></span>
        <p className="eyebrow">PRIVATE MAIL SYSTEM</p>
        <h1>WWMaxik Mail</h1>
        <p>Введите пароль для доступа к почтовому ящику.</p>
        <label>Пароль<input type="password" required autoFocus value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" /></label>
        {error && <div className="loginError">{error}</div>}
        <button className="primaryButton" disabled={loading}>{loading ? <span className="spinner" /> : "Войти"}</button>
      </form>
    </main>
  );
}
